var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardMenuItemIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.966346 15.2614V16.0114H1.71635H17.5577V16.25H0.75V0.75H0.966346V15.2614ZM10.5301 8.46483L11.0639 8.99949L11.5946 8.46184L15.6506 4.35316V12.9659H3.99199V9.88189L7.93977 5.87013L10.5301 8.46483ZM3.99198 9.65049C3.99198 9.65175 3.992 9.653 3.992 9.65426L3.99198 9.65049Z",
    stroke: "black",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardMenuItemIcon);
export default __webpack_public_path__ + "static/media/dashboard-menu-item-icon.e5b4253c63d322eae10f8d53709e389a.svg";
export { ForwardRef as ReactComponent };